// Dynamic app URLs may be absolute, encoded, or point to a handbook subpage.
export function isHandbookLink(path: string): boolean {
  try {
    const pathname = new URL(path, window.location.origin).pathname
    const handbookPrefix = /^\/handbook(?:\/|$)/i
    return handbookPrefix.test(pathname) || handbookPrefix.test(decodeURIComponent(pathname))
  } catch { return false }
}

export function canShowHandbookLink(path: string, allowed: boolean): boolean {
  return allowed || !isHandbookLink(path)
}
